import React from "react";
import I18n from "i18n-js";

import Card from "./Card";

import Tooltip from "../../Chat/components/Tooltip";

const TeamStage = ({ forming, storming, norming, performing, current_stage }) => {

  const stages = { forming, storming, norming, performing };

  const calculateWidth = (score) => {
    return (score * 194).toFixed(0) + "px";
  }

  const renderProgress = (stage, value, currentStage) => (
    <div className={`stage-progress ${currentStage ? "current-stage" : null}`}>
      <div
        className={`${stage}-progress`}
        style={{ width: calculateWidth(value) }}
      />
    </div>
  );

  const renderStages = () => {
    return Object.entries(stages).map(([stage, value], index) => (
      <div key={index} className="stage">
        <div className="stage-content">
          <div className="stage-title">
            {I18n.t(`dashboard.${stage}`)}
          </div>
          <div className="stage-score">
            {Math.floor(value * 100)}%
          </div>
        </div>
        {stage === current_stage ? (
          <Tooltip
            className="info-tooltip"
            position="bottom"
            text={I18n.t("dashboard.user_team_stage")}
          >
            {renderProgress(stage, value, true)}
          </Tooltip>
        ) : renderProgress(stage, value, false)}
      </div>
    ));
  }
    
  return (
    <div className="team-stage-section">
      <Card
        title={I18n.t('dashboard.team_stage')}
        content={
          <div className="section-content">
            {renderStages()}
          </div>
        }
      />
    </div>
  );
}

export default TeamStage;
